/* =========================================================
   ENVY CUSTOM JS
   Feature: CART DRAWER - link "Rimuovi" con aggiornamento AJAX
   Tema: Expanse
   Scopo:
   - intercetta il click sul link "Rimuovi" nel carrello a discesa
   - evita il redirect alla pagina /cart
   - rimuove il prodotto via Shopify Ajax Cart API
   - aggiorna il drawer
   - aggiorna il badge numerico dell'icona carrello nell'header
   ========================================================= */

(function () {
  // Evita che lo script venga inizializzato due volte
  if (window.__envyDrawerRemoveInit) return;
  window.__envyDrawerRemoveInit = true;

  /* ---------------------------------------------------------
     Recupera il contenitore principale del cart drawer
     --------------------------------------------------------- */
  function getDrawerRoot() {
    return document.querySelector('header-cart-drawer.cart-drawer[cart-type="dropdown"]');
  }

  /* ---------------------------------------------------------
     Recupera tutti gli item attualmente presenti nel drawer
     Serve per calcolare la posizione reale della riga cliccata
     --------------------------------------------------------- */
  function getCartItems() {
    const drawer = getDrawerRoot();
    if (!drawer) return [];
    return Array.from(drawer.querySelectorAll('.cart__items .cart__item'));
  }

  /* ---------------------------------------------------------
     Shopify Ajax Cart API può rimuovere un prodotto usando
     il numero di linea (1-based index) del carrello.
     Questa funzione calcola la linea del prodotto cliccato.
     --------------------------------------------------------- */
  function getLineIndex(cartItem) {
    const items = getCartItems();
    const index = items.indexOf(cartItem);
    return index === -1 ? null : index + 1;
  }

  /* ---------------------------------------------------------
     Forza il rebuild del cart drawer
     Utile per far aggiornare il contenuto del drawer dopo
     la rimozione via AJAX
     --------------------------------------------------------- */
  function rebuildCartDrawer() {
    try {
      document.dispatchEvent(new CustomEvent('cart:build'));
    } catch (e) {
      console.warn('Envy: impossibile dispatchare cart:build', e);
    }
  }

  /* ---------------------------------------------------------
     Aggiorna il badge numerico dell'icona carrello in header
     - aggiorna il numero
     - mostra/nasconde il bubble in base al conteggio
     --------------------------------------------------------- */
  function updateHeaderCartBubble(itemCount) {
    const bubble = document.querySelector('.cart-link__bubble');
    const bubbleNum = document.querySelector('.cart-link__bubble-num');

    if (!bubble || !bubbleNum) return;

    const count = Number(itemCount) || 0;
    bubbleNum.textContent = String(count);

    if (count > 0) {
      bubble.classList.add('cart-link__bubble--visible');
    } else {
      bubble.classList.remove('cart-link__bubble--visible');
    }
  }

  /* ---------------------------------------------------------
     Rimuove una riga del carrello via Shopify Ajax API
     Imposta quantity: 0 sulla linea selezionata
     Ritorna il carrello aggiornato in formato JSON
     --------------------------------------------------------- */
  async function removeLineByIndex(lineIndex) {
    const root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const response = await fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        line: lineIndex,
        quantity: 0
      })
    });

    if (!response.ok) {
      let errorText = '';
      try {
        errorText = await response.text();
      } catch (e) {}
      throw new Error('cart/change.js error ' + response.status + ' ' + errorText);
    }

    return response.json();
  }

  /* ---------------------------------------------------------
     Listener principale:
     intercetta il click sul link "Rimuovi" nel cart drawer
     --------------------------------------------------------- */
  document.addEventListener('click', async function (event) {
    const link = event.target.closest(
      'header-cart-drawer.cart-drawer[cart-type="dropdown"] .cart__item-remove a'
    );

    // Se il click non arriva dal link "Rimuovi", esce
    if (!link) return;

    // Blocca il comportamento nativo del link
    // così evita il redirect alla pagina /cart
    event.preventDefault();

    const cartItem = link.closest('.cart__item');
    if (!cartItem) return;

    // Calcola la linea Shopify del prodotto cliccato
    const lineIndex = getLineIndex(cartItem);
    if (!lineIndex) return;

    // Evita doppi click durante la rimozione
    if (link.dataset.envyRemoving === 'true') return;
    link.dataset.envyRemoving = 'true';
    link.style.pointerEvents = 'none';
    link.style.opacity = '0.5';

    try {
      // Rimuove il prodotto via AJAX
      const cart = await removeLineByIndex(lineIndex);

      // Aggiorna il badge dell'header con il nuovo item_count
      updateHeaderCartBubble(cart.item_count);

      // Ricostruisce il drawer per mostrare il carrello aggiornato
      rebuildCartDrawer();
    } catch (error) {
      console.error('Envy remove from drawer error:', error);
    } finally {
      // Riabilita il link dopo un piccolo delay
      setTimeout(function () {
        link.dataset.envyRemoving = 'false';
        link.style.pointerEvents = '';
        link.style.opacity = '';
      }, 500);
    }
  });
})();

